/**
 * Returns an array of objects containing category and subcategory data.
 *
 * @param {Object} ResponseValues - An object containing category and subcategory data.
 * @returns {Array} An array of objects containing category and subcategory data.
 */
export const getCatSubCat = (ResponseValues) => {
  const res = [];
  let res2 = [];

  // CATEGORIES
  const cat = Object.keys(ResponseValues.data)
    .filter((key) => ResponseValues.data[key].parent_id === null)
    .map((key) => ResponseValues.data[key]);

  // SUBCATEGORIES
  const subCat = Object.keys(ResponseValues.data)
    .filter((key) => ResponseValues.data[key].parent_id !== null)
    .map((key) => ResponseValues.data[key]);

  // CREATE ARRAY WITH CATEGORY AND SUBCATEGORY
  Object.keys(cat).map((key) => {
    Object.keys(subCat)
      .filter((keySub) => cat[key].id === subCat[keySub].parent_id)
      .map((keySub) => res2.push(subCat[keySub]));
    res.push({ values: cat[key], sub: res2 });
    res2 = [];
    return true;
  });

  return res;
};
